import { ResponseError } from '@/apis/generated/dialpad-contact';

export const isRetryError = (error: unknown): boolean => {
  return error instanceof ResponseError && error.response.status >= 500;
};
